import React, { useState } from "react";
import { AiFillLinkedin, AiFillGithub, AiOutlineDownload } from "react-icons/ai";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleClick = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) element.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gray-800 shadow-md">
      {/* Navbar content */}
      <div className="w-full max-w-7xl container mx-auto flex flex-wrap p-5 flex-row items-center justify-between font-ntr relative">
        {/* Logo + Main Nav */}
        <div className="flex items-center">
          <a
            href="#about"
            className="title-font font-medium text-white text-xl"
          >
            Connor Flynn
          </a>
          <nav className="hidden lg:flex flex-grow items-center text-white ml-4">
            <a
              href="#profile"
              className="mr-5 hover:text-[#64ffda] rounded"
              onClick={(e) => handleClick(e, "profile")}
            >
              About
            </a>
            <a
              href="#work-history"
              className="mr-5 hover:text-[#64ffda] rounded"
              onClick={(e) => handleClick(e, "work-history")}
            >
              Experience
            </a>
            <a
              href="#projects"
              className="mr-5 hover:text-[#64ffda] rounded"
              onClick={(e) => handleClick(e, "projects")}
            >
              Projects
            </a>
          </nav>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="inline-flex p-3 rounded lg:hidden text-white ml-auto hover:text-[#64ffda] outline-none"
          onClick={toggleMenu}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={
                isOpen
                  ? "M6 18L18 6M6 6l12 12"
                  : "M4 6h16M4 12h16m-7 6h7"
              }
            ></path>
          </svg>
        </button>

        {/* Links + Socials */}
        <div
          className={`${
            isOpen ? "block" : "hidden"
          } lg:flex lg:items-center w-full lg:w-auto mt-4 lg:mt-0`}
        >
          <nav className="flex flex-col lg:flex-row lg:items-center lg:space-x-4 text-white">
            {/* Mobile Nav */}
            <a
              href="#profile"
              className="block mt-4 lg:mt-0 lg:hidden mr-5 hover:text-[#64ffda] rounded"
              onClick={(e) => handleClick(e, "profile")}
            >
              About
            </a>
            <a
              href="#work-history"
              className="block mt-4 lg:mt-0 lg:hidden mr-5 hover:text-[#64ffda] rounded"
              onClick={(e) => handleClick(e, "work-history")}
            >
              Experience
            </a>
            <a
              href="#projects"
              className="block mt-4 lg:mt-0 lg:hidden mr-5 hover:text-[#64ffda] rounded"
              onClick={(e) => handleClick(e, "projects")}
            >
              Projects
            </a>

            {/* Socials */}
            <a
              className="block mt-4 lg:mt-0 text-white font-medium text-xl mr-5 hover:text-[#64ffda]"
              href="https://www.linkedin.com/in/connor-flynn-6433a3a5"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AiFillLinkedin />
            </a>
            <a
              className="block mt-4 lg:mt-0 text-white font-medium text-xl mr-5 hover:text-[#64ffda]"
              href="https://github.com/connorflynn4"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AiFillGithub />
            </a>

            {/* Resume */}
            <a
              href="./Connor_Flynn_Resume_.pdf"
              download="Connor_Flynn_Resume_.pdf"
              className="inline-flex mt-4 lg:mt-0 text-white font-medium text-xl items-center hover:text-[#64ffda]"
            >
              Download Resume
              <AiOutlineDownload className="ml-1" />
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
